export const products = [
  {
    id: "p1",
    title: `Nike Air Force 1 NDESTRUKT`,
    price: 93.229,
    priceSale: "",
    status: "",
    colors: ["#00AB55", "#000000"],
    productImage: `https://raw.githubusercontent.com/minimal-ui-kit/material-kit-react/465e1219502ff9d091b1c922cc30f25a2119a681/public/static/mock-images/products/product_1.jpg`,
  },
  {
    id: "p2",
    title: `Nike Space Hippie 04`,
    price: 85.59,
    priceSale: "",
    status: "",
    colors: ["#94D82D", "#FFC107", "#000000", "#FFFFFF"],
    productImage: `https://raw.githubusercontent.com/minimal-ui-kit/material-kit-react/465e1219502ff9d091b1c922cc30f25a2119a681/public/static/mock-images/products/product_2.jpg`,
  },
  {
    id: "p3",
    title: `Nike Air Zoom Pegasus 37 A.I.R. Chaz Bear`,
    price: 37.18,
    priceSale: 27.784,
    status: "new",
    colors: ["#FF4842", "#1890FF", "#94D82D", "#FFC107"],
    productImage: `https://raw.githubusercontent.com/minimal-ui-kit/material-kit-react/465e1219502ff9d091b1c922cc30f25a2119a681/public/static/mock-images/products/product_3.jpg`,
  },
  {
    id: "p4",
    title: `Nike Blazer Low 77 Vintage`,
    price: 85.04,
    priceSale: "",
    status: "new",
    colors: ["#FFFFFF", "#FFC0CB", "#FF4842", "#1890FF"],
    productImage: `https://raw.githubusercontent.com/minimal-ui-kit/material-kit-react/465e1219502ff9d091b1c922cc30f25a2119a681/public/static/mock-images/products/product_4.jpg`,
  },
  {
    id: "p5",
    title: `Nike ZoomX SuperRep Surge`,
    price: 40.16,
    priceSale: "",
    status: "",
    colors: ["#00AB55", "#FF4842", "#1890FF"],
    productImage: `https://raw.githubusercontent.com/minimal-ui-kit/material-kit-react/465e1219502ff9d091b1c922cc30f25a2119a681/public/static/mock-images/products/product_5.jpg`,
  },
  {
    id: "p6",
    title: `Zoom Freak 2`,
    price: 94.87,
    priceSale: 28.6,
    status: "new",
    colors: ["#FF4842"],
    productImage: `https://raw.githubusercontent.com/minimal-ui-kit/material-kit-react/465e1219502ff9d091b1c922cc30f25a2119a681/public/static/mock-images/products/product_6.jpg`,
  },
  {
    id: "p7",
    title: `Nike Air Max Zephyr`,
    price: 84.54,
    priceSale: "",
    status: "new",
    colors: ["#94D82D", "#00AB55", "#000000"],
    productImage: `https://raw.githubusercontent.com/minimal-ui-kit/material-kit-react/465e1219502ff9d091b1c922cc30f25a2119a681/public/static/mock-images/products/product_7.jpg`,
  },
  {
    id: "p8",
    title: `Jordan Delta`,
    price: 54.34,
    priceSale: "",
    status: "",
    colors: ["#FFC0CB", "#FF4842"],
    productImage: `https://raw.githubusercontent.com/minimal-ui-kit/material-kit-react/465e1219502ff9d091b1c922cc30f25a2119a681/public/static/mock-images/products/product_8.jpg`,
  },
  {
    id: "p9",
    title: `Air Jordan XXXV PF`,
    price: 46.1,
    priceSale: 24.24,
    status: "sale",
    colors: ["#000000", "#FFFFFF", "#FFC0CB"],
    productImage: `https://raw.githubusercontent.com/minimal-ui-kit/material-kit-react/465e1219502ff9d091b1c922cc30f25a2119a681/public/static/mock-images/products/product_9.jpg`,
  },
  {
    id: "p10",
    title: `Nike Waffle Racer Crater`,
    price: 21.94,
    priceSale: "",
    status: "",
    colors: ["#1890FF", "#94D82D", "#FFC107"],
    productImage: `https://raw.githubusercontent.com/minimal-ui-kit/material-kit-react/465e1219502ff9d091b1c922cc30f25a2119a681/public/static/mock-images/products/product_10.jpg`,
  },
];
